
import Vue from "vue";
import CambioPropietarioService from '@/services/CambioPropietarioService';
import EventBus from "@/plugins/event-bus";
import CustomFile from "@/components/Common/CustomFile.vue";
import rules from '@/mixins/rules';
import AlertasPredial from '@/components/Solicitudes/AlertasPredial.vue';
import { CambioPropietario } from '@/models/CambioPropietario';
import ContribuyenteService from "@/services/ContribuyenteService";
import LicenciaActualComponent from '@/components/Common/LicenciaActual.vue';
import { mapGetters } from "vuex";
import EstablecimientoService from '@/services/EstablecimientoService';

export default Vue.extend({
    name: 'CambioPropietario',
    mixins: [rules],
    components: {
        CustomFile,
        AlertasPredial,
        LicenciaActualComponent
    },
    props: {
        establecimiento: {
            type: Object,
            default: {} as any,
        },
        dialogPrincipal: {
            type: Boolean,
        },
        renovacion: {
            type: Boolean,
            default: false
        },
        establecimientoRenovacion: {
            type: Object,
            default: {} as any,
        }
    },
    data() {
        return {
            dialog: false,
            dialogContribuyente: false,
            dialogView: false,
            dialogPredial: false,
            dialogRechazar: false,
            dialogBusqueda: false,
            dialogConfirmar: false,
            documento: {} as any,
            formDataNueva: new CambioPropietario(),
            disabled: false,
            solicitudes: [] as any,
            solicitud: {} as any,
            idSolicitud: null,
            motivoRechazo: '',
            rfc: '',
            contribuyente: null as any,
            oldContribuyente: null as any,
            tipoPropiedades: [],
            selectedSolicitud: {} as any,
        }
    },
    watch: {
        dialogPrincipal: {
            handler(newVal) {
                if (this.dialogPrincipal && !this.renovacion) {
                    this.getSolicitudesCambioPropietario(this.establecimiento);
                    this.getTiposPredios();
                }
            },
            deep: true,
        },
        dialog() {
            if (this.dialog && !this.renovacion) {
                if (!this.formDataNueva.id) {
                    this.formDataNueva.has_alcohol = this.hasAlcohol;
                    this.getByID(this.establecimiento.contribuyente_id);
                }
            }
        },
        renovacion(newVal) {
            if (this.renovacion) {
                this.dialog = true;
                if (!this.formDataNueva.new_contribuyente_id) {
                    this.contribuyente = this.contribuyenteRenovacion;
                    this.formDataNueva.new_contribuyente_id = this.contribuyenteRenovacion.id;
                    this.formDataNueva.new_rfc = this.contribuyenteRenovacion.rfc;
                }
            }
        },
        establecimientoRenovacion(newVal) {
            if (this.renovacion) {
                this.formDataNueva.old_rfc = this.establecimientoRenovacion.rfc;
                this.getTiposPredios();
            }
        }
    },
    methods: {
        agregarSolicitud() {
            /* this.dialogContribuyente = true; */
            //this.dialogBusqueda = true;
            this.dialogContribuyente = true;
        },
        closeDialogContribuyente() {
            this.dialogContribuyente = false;
            this.disabled = false;
            if (!this.formDataNueva.id) {
                this.formDataNueva = new CambioPropietario();
            }
            this.$emit('closeCambioPropietario');
        },
        closeDialogContribuyenteRenovacion() {
            this.dialogContribuyente = false;
            this.disabled = false;
            this.$emit('closeCambioPropietario');
        },
        closeDialogPredial() {
            this.dialogPredial = false;
        },
        closeDialog() {
            this.disabled = false;
            this.dialog = false;
            this.solicitud = {};
            this.formDataNueva = {
                ...new CambioPropietario(),
            }
            this.oldContribuyente = null as any;
            this.contribuyente = null as any;
        },
        closeDialogRenovacion() {
            this.disabled = false;
            this.dialog = false;
            this.solicitud = {};
            this.oldContribuyente = null as any;
            this.$emit('closeCambioPropietario');
            //@ts-ignorec
            let validate = this.$refs.form.validate();
            let formDataPredial = new FormData();
            let formDataFotos = new FormData();
            const formData = this.objectFormData(this.formDataNueva);
            //@ts-ignore
            formDataPredial = this.objectToFormData(this.formDataNueva.predial, formDataPredial)
            //@ts-ignore
            formDataFotos = this.objectToFormData(this.formDataNueva.fotos, formDataFotos)

            this.$emit('validateForm', validate, formData, formDataPredial, formDataFotos);
        },
        async getByRFC() {
            this.contribuyente = null as any;
            await ContribuyenteService.getByRFC(this.rfc)
                .then((response) => {
                    let res = response.data;
                    if (res.success) {
                        this.$toast.success(response.data.message);
                        this.contribuyente = res.data;
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
        },
        getSolicitudesCambioPropietario(item: any) {
            CambioPropietarioService.getSolicitudesCambioPropietario(item.id)
                .then((response) => {
                    //console.log(response);
                    this.solicitudes = response.data;
                })
        },
        cerrar() {
            this.disabled = false;
            this.formDataNueva = new CambioPropietario();
            this.$emit('close', this.dialog);
        },
        async guardarSolicitud(item: any) {
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                const formData = this.objectFormData(this.formDataNueva);
                await CambioPropietarioService.setSolicitudCambioPropietario(item.id, formData)
                    .then(async (response) => {
                        this.$toast.success(response.data.message);
                        let solicitud = response.data.data;
                        let formDataPredial = new FormData();
                        let formDataFotos = new FormData();
                        //@ts-ignore
                        formDataPredial = this.objectToFormData(this.formDataNueva.predial, formDataPredial)
                        formDataPredial.append('solicitud_id', solicitud.id);

                        const responseFilesPredial = await CambioPropietarioService.storeFiles(item.id, solicitud.id, formDataPredial)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Documentos adjuntados con exito");
                                }
                            })

                        //@ts-ignore
                        formDataFotos = this.objectToFormData(this.formDataNueva.fotos, formDataFotos)
                        formDataFotos.append('solicitud_id', solicitud.id);

                        const responseFilesFotos = await CambioPropietarioService.storeFiles(item.id, solicitud.id, formDataFotos)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Fotos adjuntados con exito");
                                }
                            })
                        this.verSolicitud(solicitud);
                        this.getSolicitudesCambioPropietario(this.establecimiento);
                    })
                    .catch((error) => {
                        //this.$toast.error(error.response.data.message);
                    })
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        objectFormData(data: any) {
            const formData = new FormData();
            formData.append(`id`, data.id);
            formData.append(`new_contribuyente_id`, data.new_contribuyente_id);
            formData.append(`old_contribuyente_id`, data.old_contribuyente_id ? data.old_contribuyente_id : '');
            formData.append(`renovacion`, data.renovacion as any ? 1 : 0 as any);
            formData.append(`has_licencia_bebidas`, data.has_licencia_bebidas as any ? 1 : 0 as any);
            formData.append(`patente_propia`, data.patente_propia ? 1 : 0 as any);
            formData.append(`folio_licencia_bebida_alcoholica`, data.folio_licencia_bebida_alcoholica ? data.folio_licencia_bebida_alcoholica : '');
            formData.append(`has_alcohol`, this.hasAlcohol ? 1 : 0 as any);
            formData.append(`tiene_uso_suelo`, data.tiene_uso_suelo ? 1 : 0 as any);
            formData.append(`old_rfc`, data.old_rfc ? data.old_rfc : '');
            formData.append(`new_rfc`, data.new_rfc ? data.new_rfc : '');
            formData.append(`tipo_proceso_id`, data.tipo_proceso_id ? data.tipo_proceso_id : '');
            formData.append(`tipo_propiedad_id`, data.tipo_propiedad_id ? data.tipo_propiedad_id : '');
            formData.append(`superficie`, data.superficie ? data.superficie : 0 as any);

            Object.entries(data.documentos).forEach(([key, documento]) => {
                let d = documento as any;
                const baseKey = `files[${key}]`;
                formData.append(`${baseKey}[file]`, d.file);
                formData.append(`${baseKey}[code]`, key);
            });

            return formData;
        },
        verSolicitud(item: any) {
            CambioPropietarioService.getSolicitudCambioPropietario(this.establecimiento.id, item.id)
                .then((response) => {
                    this.dialog = true;
                    let solicitud = response.data;
                    this.solicitud = solicitud;
                    this.formDataNueva.id = solicitud.id;
                    this.formDataNueva.renovacion = solicitud.renovacion ? 1 : 0;
                    this.formDataNueva.folio_licencia_bebida_alcoholica = solicitud.folio_licencia_bebida_alcoholica;
                    this.formDataNueva.has_alcohol = solicitud.has_alcohol ? true : false;
                    this.formDataNueva.new_contribuyente_id = solicitud.new_contribuyente_id;
                    this.formDataNueva.old_contribuyente_id = solicitud.old_contribuyente_id;
                    this.formDataNueva.tiene_uso_suelo = solicitud.tiene_uso_suelo ? true : false;
                    this.formDataNueva.old_rfc = solicitud.old_rfc;
                    this.formDataNueva.new_rfc = solicitud.new_rfc;
                    this.contribuyente = solicitud.new_contribuyente;
                    this.formDataNueva.tipo_proceso_id = solicitud.tipo_proceso_id;
                    this.formDataNueva.tipo_propiedad_id = solicitud.tipo_propiedad_id;
                    this.formDataNueva.superficie = solicitud.superficie;
                    this.formDataNueva.patente_propia = solicitud.patente_propia == 1 ? true : false;
                    //console.log("solicitud patente propia",solicitud.patente_propia);
                    //console.log("patente propia",this.formDataNueva.patente_propia);
                    this.setFiles(solicitud);

                    if (this.solicitud.estatus_id != 1 && this.solicitud.estatus_id != 5) {
                        this.disabled = true;
                    }
                    if (this.formDataNueva.old_contribuyente_id) {
                        this.getByID(this.formDataNueva.old_contribuyente_id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        setFiles(solicitud: any) {
            const fotos = ['frente', 'interior', 'wc', 'lateralDerecho', 'lateralIzquierdo'];
            if (solicitud.saneamiento) {
                const saneamiento = solicitud.saneamiento;
                this.formDataNueva.documentos['scap_saneamiento'].code = 'scap_saneamiento';
                this.formDataNueva.documentos['scap_saneamiento'].data = saneamiento;
            }

            if (solicitud.licencia_alcohol) {
                const licenciaAlcohol = solicitud.licencia_alcohol;
                this.formDataNueva.documentos['scap_licencia'].code = 'scap_licencia';
                this.formDataNueva.documentos['scap_licencia'].data = licenciaAlcohol;
            }

            if (solicitud.licencia_bebida) {
                const licenciaBebidas = solicitud.licencia_bebida;
                this.formDataNueva.documentos['scap_pago_licencia_bebidas'].code = 'licencia_bebidas';
                this.formDataNueva.documentos['scap_pago_licencia_bebidas'].data = licenciaBebidas;
            }

            if (solicitud.licencia_comodato) {
                const licenciaComodato = solicitud.licencia_comodato;
                this.formDataNueva.documentos['scap_licencia_comodato'].code = 'scap_licencia_comodato';
                this.formDataNueva.documentos['scap_licencia_comodato'].data = licenciaComodato;
            }

            if (solicitud.aviso_cierre) {
                const avisoCierre = solicitud.aviso_cierre;
                this.formDataNueva.documentos['aviso_cierre'].code = 'aviso_cierre';
                this.formDataNueva.documentos['aviso_cierre'].data = avisoCierre;
            }

            if (solicitud.aviso_apertura) {
                const avisoApertura = solicitud.aviso_apertura;
                this.formDataNueva.documentos['aviso_apertura'].code = 'aviso_apertura';
                this.formDataNueva.documentos['aviso_apertura'].data = avisoApertura;
            }

            if (solicitud.constancia_uso_suelo) {
                const constanciaUS = solicitud.constancia_uso_suelo;
                this.formDataNueva.documentos['constancia_us_cap'].code = 'constancia_us_cap';
                this.formDataNueva.documentos['constancia_us_cap'].data = constanciaUS;
            }

            let predial: [] = solicitud.predial.filter((archivo: any) => !fotos.includes(archivo.archivo.tipo_archivo)).map((archivo: any) => {
                return {
                    code: archivo.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: archivo.archivo
                }
            });

            const frente = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "frente");
            if (frente != undefined) {
                this.formDataNueva.fotos.frente = {
                    code: frente.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: frente.archivo
                }
            }

            const interior = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "interior");
            if (interior != undefined) {
                this.formDataNueva.fotos.interior = {
                    code: interior.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: interior.archivo
                }
            }
            const wc = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "wc");
            if (wc != undefined) {
                this.formDataNueva.fotos.wc = {
                    code: wc.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: wc.archivo
                }
            }
            const lateralIzquierdo = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "lateralIzquierdo");
            if (lateralIzquierdo != undefined) {
                this.formDataNueva.fotos.lateralIzquierdo = {
                    code: lateralIzquierdo.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: lateralIzquierdo.archivo
                }
            }
            const lateralDerecho = solicitud.fotos.find((archivo: any) => archivo.archivo.tipo_archivo == "lateralDerecho");
            if (lateralDerecho != undefined) {
                this.formDataNueva.fotos.lateralDerecho = {
                    code: lateralDerecho.archivo.tipo_archivo,
                    file: '',
                    binary: '',
                    data: lateralDerecho.archivo
                }
            }

            let finalDocuments = [] as any;

            predial.forEach((element: any, index: any) => {
                if (!finalDocuments.hasOwnProperty(element.code)) {
                    finalDocuments[element.code] = element;
                }
            });

            //@ts-ignore
            this.formDataNueva.predial = {
                ...this.formDataNueva.predial,
                //@ts-ignore
                ...finalDocuments
            };
        },
        changeStatusSolicitudCambioPropietario(item: any, estatus: any) {
            let data = {
                estatus_id: estatus
            }
            CambioPropietarioService.changeStatusSolicitudCambioPropietario(this.establecimiento.id, item.id, data)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.getSolicitudesCambioPropietario(this.establecimiento);
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    //this.$toast.error(error.response.data.message);
                });
        },
        closeDialogRechazar() {
            this.disabled = false;
            this.dialogRechazar = false;
            this.motivoRechazo = '';
            this.solicitud = {};
        },
        verMotivoRechazo(item: any) {
            this.solicitud = item;
            this.dialogRechazar = true;
            this.motivoRechazo = item.motivo_rechazo;
        },
        async updateSolicitudCambioPropietario(item: any) {
            EventBus.$emit('update-direccion');
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                const formData = this.objectFormData(this.formDataNueva);
                await CambioPropietarioService.updateSolicitudCambioPropietario(this.establecimiento.id, item.id, formData)
                    .then(async (response) => {
                        this.$toast.success(response.data.message);
                        let solicitud = response.data.data;
                        let formDataPredial = new FormData();
                        let formDataFotos = new FormData();
                        //@ts-ignore
                        formDataPredial = this.objectToFormData(this.formDataNueva.predial, formDataPredial)
                        formDataPredial.append('solicitud_id', solicitud.id);

                        await CambioPropietarioService.storeFiles(this.establecimiento.id, item.id, formDataPredial)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Documentos adjuntados con exito");
                                }
                            })

                        //@ts-ignore
                        formDataFotos = this.objectToFormData(this.formDataNueva.fotos, formDataFotos)
                        formDataFotos.append('solicitud_id', solicitud.id);

                        await CambioPropietarioService.storeFiles(this.establecimiento.id, item.id, formDataFotos)
                            .then((response) => {
                                //@ts-ignore
                                if (response.status === 200) {
                                    this.$toast.success("Fotos adjuntados con exito");
                                }
                            })

                        this.verSolicitud(solicitud);
                        this.getSolicitudesCambioPropietario(this.establecimiento);
                    })
                    .catch((error) => {
                        //this.$toast.error(error.response.data.message);
                    })
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        selectContribuyente(contribuyente: any) {
            this.formDataNueva.new_contribuyente_id = contribuyente.id;
            this.formDataNueva.new_rfc = contribuyente.rfc;
            this.dialogContribuyente = false;
            this.dialog = true;
        },
        async getByID(contribuyente_id: any) {
            this.oldContribuyente = null as any;
            await ContribuyenteService.getByID(contribuyente_id)
                .then((response) => {
                    let res = response.data;
                    if (res.success) {
                        this.oldContribuyente = res.data;
                        this.formDataNueva.old_contribuyente_id = this.oldContribuyente.id;
                        this.formDataNueva.old_rfc = this.oldContribuyente.rfc;
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
        },
        failBusqueda() {
            this.dialogBusqueda = false;
        },
        openContribuyente() {
            this.dialogContribuyente = true;
        },
        closeBusqueda() {
            this.dialogBusqueda = false;
        },
        isValidated() {
            // @ts-ignore
            return this.$refs.form.validate();
        },
        async getTiposPredios() {
            await EstablecimientoService.getTipoPropiedades().then((response) => {
                this.tipoPropiedades = response.data;
            });
        },
        objectToFormData(obj: any, formData: any) {
            let counterItems = 0;
            Object.entries(obj).forEach(([key, value]) => {
                //@ts-ignore
                formData.append(`documento[${counterItems}][file]`, value.file);
                formData.append(`documento[${counterItems}][code]`, key);
                counterItems++;
            });
            return formData;
        },
        openDialogConfirmar(item: any) {
            this.selectedSolicitud = item;
            this.dialogConfirmar = true;
        },
        closeDialogConfirmar() {
            this.dialogConfirmar = false;
            this.selectedSolicitud = {} as any;
        },
        deleteSolicitudCambioPropietario(item: any) {
            this.dialogConfirmar = false;
            let data = {}
            CambioPropietarioService.deleteSolicitudCambioPropietario(this.establecimiento.id, item.id, data)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.getSolicitudesCambioPropietario(this.establecimiento);
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    //this.$toast.error(error.response.data.message);
                });
        },
    },
    computed: {
        hasAlcohol() {
            if (this.renovacion) {
                if (this.establecimientoRenovacion?.has_alcohol_giro) {
                    return true;
                }
                return false;
            }
            if (this.establecimiento?.has_alcohol_giro || this.establecimiento?.has_alcohol_actividad.length > 0) {
                return true;
            }
            return false;
        },
        esHoteleria() {
            if (this.renovacion) {
                if (this.establecimientoRenovacion?.is_hoteleria) {
                    return true;
                }
                return false;
            }
            if (this.establecimiento?.is_hoteleria) {
                return true;
            }
            return false;
        },
        ...mapGetters({
            contribuyenteRenovacion: "contribuyente",
        }),
        isNotOwner() {
            if (this.formDataNueva.tipo_propiedad_id != 1 && this.formDataNueva.tipo_propiedad_id != 4 && this.formDataNueva.tipo_propiedad_id != null) {
                return true;
            }
            return false;
        },
        isBaldio() {
            if (this.formDataNueva.tipo_propiedad_id == 4) {
                return true;
            }
            return false;
        },
    },
    mounted() {

    }
})
